// Pure, side-effect-free helpers extracted from ProductPage.tsx (SRP). Each takes
// data in and returns data out - no hooks, no component state, no JSX - so moving
// them out of the page changes no rendered output or behavior.

/** Humanize an enum code for display, e.g. "TREE_NUTS" → "tree nuts". */
export function pretty(code: string): string {
  return code.toLowerCase().replace(/_/g, ' ');
}

/** Shallow-copy an unknown value into a plain localized-string record. */
export function toLocalizedRecord(v: unknown): Record<string, string> {
  return v && typeof v === 'object' ? { ...(v as Record<string, string>) } : {};
}

/** Toggle a code in/out of a list, returning a new array. */
export function toggleIn<T>(list: readonly T[], code: T): T[] {
  return list.includes(code) ? list.filter((c) => c !== code) : [...list, code];
}

/**
 * The restaurant's currency symbol (e.g. €, $, ₫) for the given currency code -
 * same derivation as the create form's AdvancedZone. Falls back to the raw code.
 */
export function currencySymbolOf(currency: string): string {
  try {
    return (
      new Intl.NumberFormat(undefined, { style: 'currency', currency })
        .formatToParts(0)
        .find((p) => p.type === 'currency')?.value ?? currency
    );
  } catch {
    return currency;
  }
}
